var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_958)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 0C12.9839 0 0 12.9839 0 29C0 45.0161 12.9839 58 29 58C45.0161 58 58 45.0161 58 29C58 12.9839 45.0161 0 29 0ZM16.9414 28.9191C16.5579 28.5617 16.0506 28.3671 15.5264 28.3764C15.0022 28.3856 14.5021 28.598 14.1314 28.9687C13.7607 29.3393 13.5484 29.8395 13.5392 30.3636C13.5299 30.8878 13.7245 31.3951 14.0819 31.7786L22.1749 39.8716C22.5542 40.2505 23.0685 40.4633 23.6047 40.4633C24.1408 40.4633 24.6551 40.2505 25.0344 39.8716L43.9181 20.9879C44.2755 20.6044 44.4701 20.0971 44.4608 19.5729C44.4516 19.0488 44.2393 18.5486 43.8686 18.1779C43.4979 17.8073 42.9978 17.5949 42.4736 17.5857C41.9494 17.5764 41.4421 17.771 41.0586 18.1284L23.6047 35.5823L16.9414 28.9191Z",
    fill: "#FE6F61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCheck);
export default __webpack_public_path__ + "static/media/big_check.4accbd10529a995c7183f1b4a3a20ec9.svg";
export { ForwardRef as ReactComponent };